exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".colored-square{display:inline-block;width:9px;height:9px;box-sizing:border-box;border:.5px solid rgba(0,0,0,.1);margin-right:3px}", ""]);

